import { Chip } from '@emailforge/ui';

import { useGetUsageQuery } from '@/features/usage/usageApi';

export function UsageMeter() {
  const { data, isLoading } = useGetUsageQuery();

  if (isLoading || !data) {
    return (
      <div className="mf-card" style={{ padding: 18 }}>
        <div className="mf-card-title" style={{ fontSize: 13 }}>Usage · this month</div>
        <div style={{ fontSize: 12.5, color: 'var(--ink-3)', marginTop: 10 }}>Loading…</div>
      </div>
    );
  }

  const sendsLimit = data.limits.sends;
  const templatesLimit = data.limits.templates;

  return (
    <div className="mf-card" style={{ padding: 18 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 14 }}>
        <div style={{ fontSize: 13, fontWeight: 550 }}>Usage · this month</div>
        <Chip  style={{ marginLeft: 'auto' }}>{data.plan}
        </Chip>
      </div>

      <Meter label="Sends" current={data.sends} limit={sendsLimit} />
      <div style={{ height: 12 }} />
      <Meter label="Templates" current={data.templates} limit={templatesLimit} />
      <div style={{ height: 12 }} />
      <Meter label="API calls" current={data.apiCalls} limit="unlimited" />
    </div>
  );
}

function Meter({
  label,
  current,
  limit,
}: {
  label: string;
  current: number;
  limit: number | 'unlimited';
}) {
  const ratio = typeof limit === 'number' ? Math.min(1, current / Math.max(1, limit)) : 0;
  const nearLimit = ratio >= 0.8;
  const atLimit = ratio >= 1;
  const color = atLimit ? 'var(--err)' : nearLimit ? 'var(--warn)' : 'var(--flame)';

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 6 }}>
        <span className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: 0.06 }}>
          {label}
        </span>
        <div style={{ flex: 1 }} />
        <span className="mono" style={{ fontSize: 11.5, fontWeight: 500 }}>
          {current.toLocaleString()}
          {limit === 'unlimited' ? (
            <span style={{ color: 'var(--ink-3)' }}> / unlimited</span>
          ) : (
            <span style={{ color: 'var(--ink-3)' }}> / {limit.toLocaleString()}</span>
          )}
        </span>
      </div>
      <div
        style={{
          height: 6,
          borderRadius: 999,
          background: 'var(--paper-4)',
          overflow: 'hidden',
        }}
      >
        {limit !== 'unlimited' && (
          <div
            style={{
              height: '100%',
              width: `${ratio * 100}%`,
              background: color,
              transition: 'width 200ms ease',
            }}
          />
        )}
      </div>
    </div>
  );
}
